<template>
    <div class="card" v-show="loaded">

        <div class="card-header border-0">
            <div class="row">
                <div class="col-6">
                    <h3 class="mb-0 text-uppercase">{{ $t('common.owners') }}</h3>
                </div>
                <div class="col-6 text-right">
                    <base-button type="primary" size="sm" @click="ctrl.create()">
                        <span class="btn-inner--icon"><i class="tim-icons icon-e-add"></i></span>
                        <span class="btn-inner--text">{{ $t('owners.new') }}</span>
                    </base-button>
                </div>
            </div>
        </div>

        <p class="card-body pt-0 text-sm" v-if="empty">{{ $t('owners.no-owner') }}</p>

        <div class="pt-2" v-if="!empty">
            
            <table-control :paging="ctrl.paging" :search="true" v-model="search"></table-control>

            <el-table class="table-responsive table-flush"
                    header-row-class-name="thead-light"
                    :data="ctrl.rows">

                <el-table-column :label="$t('common.name')">
                    <template v-slot="{row}">
                        <h4 class="mb-0">
                            {{ row.name }}
                        </h4>
                    </template>
                </el-table-column>

                <el-table-column width="80" :label="$t('common.origin')">
                    <template v-slot="{row}">
                        <badge type="warning" v-if="row.origin == 'local'">{{ row.origin }}</badge>
                        <badge type="secondary" v-else>{{ row.origin }}</badge>
                    </template>
                </el-table-column>

                <el-table-column align="right" class-name="actions">
                    <template v-slot="{row}">
                        <div class="table-actions">

                            <a href="#" class="table-action text-danger" @click.prevent="ctrl.delete(row.id)">
                                <i class="tim-icons icon-simple-remove"></i>
                            </a>

                            <a href="#" class="table-action text-primary" @click.prevent="ctrl.update(row.id)">
                                <i class="tim-icons icon-pencil"></i>
                            </a>
                        </div>
                    </template>
                </el-table-column>
                
            </el-table>

            <table-pagination :paging="ctrl.paging"></table-pagination>
        </div>

        <portal to="modals">

            <form-modal v-model="ctrl.modals.edit"
                :title="$t('common.owner')"
                :loading="ctrl.form.loading"
            >
                <owner-form v-model="ctrl.form.data"
                    :errors="ctrl.form.errors"
                    :modal="ctrl.modals.edit"
                >
                </owner-form>
            </form-modal>

            <confirm-modal v-model="ctrl.modals.confirmDelete">
                <p>{{ $t('owners.delete-confirm') }}</p>
            </confirm-modal>

        </portal>

    </div>
</template>

<script>
    import CrudController from '@trax/classes/CrudController'
    import OwnerForm from './OwnerForm'

    export default {

        components: {
            OwnerForm
        },

        data() {
            return {
                loaded: false,
                ctrl: new CrudController({
                    endpoint: '/trax/api/front/owners',
                    mapData: this.mapData,
                    unmapData: this.unmapData,
                    paging: {
                        perPage: 10,
                        perPageOptions: [5, 10, 25, 50],
                        total: 0
                    },
                    query: {
                        sort: ['name']
                    }
                }),
                search: '',
            }
        },

        computed: {
            empty() {
                return this.ctrl.rows.length ==0 && !this.search
            }
        },

        created() {
            this.ctrl.init(this, 'ctrl').then(resp => {
                this.loaded = true
            })
        },

        watch: {
            search(val) {
                this.ctrl.filterMore({ name: {$text: val} })
            }
        },

        methods: {
            
            mapData(owner) {
                return {
                    id: owner ? owner.id : null,
                    name: owner ? owner.name : null,
                    origin: owner ? owner.origin : null,
                }
            },

            unmapData(data) {
                return data
            }
        }
    }
</script>

<style scoped>

    .card >>> .el-table .cell {
        line-height: 1.5;
    }
    .card >>> td,
    .card >>> th {
        padding-right: 0;
    }
    .card >>> td.actions,
    .card >>> th.actions {
        padding-left: 0;
        padding-right: 1.5rem;
    }

</style>